import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const OtherProductsApi = createAsyncThunk(
  'OtherProductsApi',
  async (productsPayload, { dispatch }) => {
    dispatch({ type: 'OtherProductsApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum } = productsPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerdashboard/other_products',
      payload: {
        customerRefNum,
        appId: APP_ID,
        appVersion: APP_VERSION,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const otherProductsRes = res;
        dispatch({
          type: 'OtherProductsApi/fulfilled',
          payload: otherProductsRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'OtherProductsApi/rejected', payload: err });
      },
    });
  }
);

export const OtherProductsApi_extrareducer = {
  [OtherProductsApi.pending]: (state, action) => {
    state.otherProductsApiState.isLoading = true;
  },
  [OtherProductsApi.fulfilled]: (state, action) => {
    state.otherProductsApiState.isLoading = false;
    state.otherProductsApiState.isSuccess = true;
    state.otherProductsApiState.isError = false;
    state.otherProductsApiState.response = action.payload;
  },
  [OtherProductsApi.rejected]: (state, action) => {
    state.otherProductsApiState.isLoading = false;
    state.otherProductsApiState.isSuccess = false;
    state.otherProductsApiState.isError = true;
    state.otherProductsApiState.response = action.payload;
  },
};
